import { request } from '@/api'

/**
 * `POST /v1/enterprise/onboarding/ai-account/oauth-failed`: the AI account card reports a blocked Claude pop-up here
 * (#1719), the one authorization failure only the browser sees. The session says whose it is, so nothing is sent: no
 * code, state or token, and no enterprise or event name the server would have to trust. A failed start or complete
 * is recorded by the server where it happens, so this is called for a blocked pop-up only.
 */
export async function reportClaudeOAuthBlocked(): Promise<void> {
    await request<void>('/v1/enterprise/onboarding/ai-account/oauth-failed', { method: 'POST' })
}
